// material-ui
import { alpha, createTheme } from "@mui/material/styles"

// project-imports
import ThemeOption from "./themeColors"

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode, presetColor, themeContrast) => {
  const paletteColor = ThemeOption('default', mode)

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff"
      },
      ...paletteColor,
      text: {
        primary:
          mode === "dark"
            ? alpha(paletteColor.secondary.darker, 0.87)
            : paletteColor.secondary[800],
        secondary:
          mode === "dark"
            ? alpha(paletteColor.secondary.darker, 0.45)
            : paletteColor.secondary.main,
        disabled:
          mode === "dark"
            ? alpha(paletteColor.secondary.darker, 0.1)
            : paletteColor.secondary[400]
      },
      action: {
        disabled: paletteColor.secondary.light
      },
      divider:
        mode === "dark"
          ? alpha(paletteColor.secondary.darker, 0.05)
          : alpha(paletteColor.secondary.light, 0.65),
      background: {
        paper: mode === "dark" ? paletteColor.secondary[100] : "#fff",
        default:
          themeContrast && mode !== "dark"
            ? "#fff"
            : paletteColor.secondary.lighter
      }
    }
  })
}

export default Palette
